// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function userUploadsList(params: { user_id: string }) {
  return http<{
    uploads: Array<{
      id: number
      url: string
      backgroundUrl: string | null
      contentType: string
      note: {
        id: number
        recipe: {
          id: number
          name: string
        }
      }
    }>
  }>({
    url: "/api/v1/user/{user_id}/uploads/",
    method: "get",
    params,
    pathParamNames: ["user_id"],
  })
}
